"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var ChatAudioService_1;
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatAudioServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const AudioService_1 = __importStar(require("@front/services/AudioService"));
let ChatAudioService = ChatAudioService_1 = class ChatAudioService extends client_1.RWSService {
    constructor(apiService, audioService) {
        super();
        this.apiService = apiService;
        this.audioService = audioService;
        this.isRecording = false;
        this.currentBlob = null;
    }
    /**
     * Toggle audio recording - simplified version using direct file upload
     */
    async toggleRecording(state, language = 'en', onTranscriptionComplete) {
        if (ChatAudioService_1.VERBOSE) {
            console.log('[ChatAudioService] toggleRecording called with state:', state, 'language:', language);
        }
        if (state) {
            // Start recording
            if (ChatAudioService_1.VERBOSE) {
                console.log('[ChatAudioService] Starting audio recording...');
            }
            this.isRecording = true;
            this.currentBlob = null;
            const startSuccess = await this.audioService.startRecording({
                language,
                onRecordingStart: () => {
                    if (ChatAudioService_1.VERBOSE) {
                        console.log('[ChatAudioService] Recording started');
                    }
                },
                onError: (error) => {
                    console.error('[ChatAudioService] Recording error:', error);
                    this.isRecording = false;
                }
            });
            if (!startSuccess) {
                console.error('[ChatAudioService] Failed to start recording');
                this.isRecording = false;
            }
        }
        else {
            // Stop recording
            if (ChatAudioService_1.VERBOSE) {
                console.log('[ChatAudioService] Stopping audio recording...');
            }
            try {
                const audioBlob = await this.audioService.stopRecording();
                this.isRecording = false;
                if (audioBlob && onTranscriptionComplete) {
                    if (ChatAudioService_1.VERBOSE) {
                        console.log('[ChatAudioService] Audio recorded, sending for transcription...', {
                            type: audioBlob.type,
                            size: audioBlob.size
                        });
                    }
                    try {
                        // Convert Blob to File for upload
                        const audioFile = new File([audioBlob], 'recording.webm', {
                            type: audioBlob.type || 'audio/webm'
                        });
                        const responseString = await this.apiService.back.uploadFiles('audio.speech-to-text', { audioFile }, { language });
                        const response = JSON.parse(responseString.data);
                        if (response.success) {
                            if (ChatAudioService_1.VERBOSE) {
                                console.log('[ChatAudioService] Transcription received:', response.result.text);
                            }
                            onTranscriptionComplete(response.result.text);
                        }
                        else {
                            console.error('[ChatAudioService] Transcription failed:', response.error || 'Unknown error');
                        }
                    }
                    catch (error) {
                        console.error('[ChatAudioService] API call failed:', error);
                    }
                }
            }
            catch (error) {
                console.error('[ChatAudioService] Error stopping recording:', error);
                this.isRecording = false;
            }
        }
    }
    /**
     * Get current recording status
     */
    getRecordingStatus() {
        return this.isRecording;
    }
    /**
     * Set playback volume (0-100)
     */
    setVolume(volume) {
        this.audioService.setVolume(volume);
    }
    /**
     * Force stop recording
     */
    async forceStop() {
        if (this.isRecording) {
            await this.audioService.stopRecording();
            this.isRecording = false;
        }
    }
};
exports.ChatAudioServiceInstance = ChatAudioService;
ChatAudioService.VERBOSE = true;
exports.ChatAudioServiceInstance = ChatAudioService = ChatAudioService_1 = __decorate([
    __param(0, client_1.ApiService),
    __param(1, AudioService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object, typeof (_b = typeof AudioService_1.AudioServiceInstance !== "undefined" && AudioService_1.AudioServiceInstance) === "function" ? _b : Object])
], ChatAudioService);
exports.default = ChatAudioService.getSingleton();
